import React, { useEffect, useState } from "react";
import makeStyles from "@material-ui/styles/makeStyles";
import api from "../../../common/api";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import useTheme from "@material-ui/styles/useTheme";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { BirdsAgeLabelMap } from "../../../common/enums";
const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: 140,
  },
  textField: {
    margin: theme.spacing(1),
    marginTop: theme.spacing(0)
  },
  signInButton: {
    margin: theme.spacing(2, 0)
  },
  datePicker: {
    marginTop: theme.spacing(2),
    margin: theme.spacing(1),
    minWidth: 160
  }
}));

const SingleBatchReportInput = ({
  showError,
  match,
  setValid,
  getChosenBatch,
  getChosenShedType,
  setLoading,
  showGroupBatchView
}) => {
  const theme = useTheme();
  const farmID = match.params["farmID"];
  const [batches, setBatches] = useState([]);
  const [activeBatches, setActiveBatches] = useState([]);
  const [batchIndex, setBatchIndex] = useState("");
  const [shedType, setShedType] = useState([{id:-1, shed_type:"None"}]);
  const [shedTypeIndex, setShedTypeIndex] = useState("");
  const [includeOnlyInActiveBatch, setIncludeOnlyInActiveBatch] = useState(false);
  const [originalBatches, setOriginalBatches] = useState([]);
  const [groupBatches, setGroupBatch] = useState([]);
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true
  });

  const classes = useStyles({ isDesktop });


  useEffect(()=>{
    setBatchIndex("") //Group Batch onchange
  },[showGroupBatchView])
  //Get all Batch API Call
  const getAllGroupBatches = () => {
    setLoading(true);
    showError('');

    const response = api.get(`farm/${farmID}/group-batch`);

    response.then(res => {
        setGroupBatch([...res]);
    }).catch(err => {
        if (err.message) {
            if (err.message === 'Bad Request' || err.message === 'No data found')
                showError('No Group Batches');
            else
              showError(err.message)
        } else {
            showError('Unknown Error')
        }
    }).finally(() => {
        setLoading(false);
    });
}
const onLoad = function () {
  getAllGroupBatches()
  loadBatchList()
}
  const loadBatchList = function () {
    showError("");
    setLoading(true);
    const response = api.get(`farm/${farmID}/batch`);
    //const response = api.get(`farm/20/batch`);
    response
      .then(res => {
        setOriginalBatches([
          ...res
        ])
        console.debug("event ",  originalBatches)
        if (includeOnlyInActiveBatch) {
          let tempInactiveBatches = []
          res.forEach(element => {
            console.debug(element)
            if (!element.isActive) {
              console.debug("isInactve")
              tempInactiveBatches = ([
                ...tempInactiveBatches,
                {
                  ...element
                }
              ]);
            }
          });
          setBatches(tempInactiveBatches)
          //setBatches(res)
        } else {
          let tempBatches = []
          res.forEach(element => {
            console.debug(element)
            if (element.isActive) {
              console.debug("isactve")
              tempBatches = ([
                ...tempBatches,
                {
                  ...element
                }
              ]);
            }
          });
          setBatches(tempBatches)
          setActiveBatches(tempBatches)
        }
      })
      .catch(err => {
        if (err.message) {
          if (err.message === "Bad Request" || err.message === "No data found")
            showError(err.message);
        } else {
          showError("Unknown Error");
        }
      })
      .finally(() => {
        setLoading(false);
      });
    getAllShedType();
  };
  const getAllShedType = () => {
    setLoading(true);
    showError("");

    const response = api.get(`shed_type`);

    response
      .then(res => {

        let shedData =[...res]
        for (let i = 0; i < shedData.length; i++) {
          const type = shedData[i].shed_type.toLowerCase();
          shedData[i].label = BirdsAgeLabelMap[type] || type; 
        }
        setShedType([...shedType, ...shedData]);
      })
      .catch(err => {
        if (err.message) {
          if (err.message === "Bad Request" || err.message === "No data found")
            showError("No Sheds Type");
          else showError(err.message);
        } else {
          showError("Unknown Error");
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(onLoad, [showError]);
  useEffect(() => {
    if (batchIndex !== "") {
      setValid(true);
    } else {
      setValid(false);
    }
  }, [batchIndex, setValid]);

  const onChangeOfBatches = function (index) {
    setBatchIndex(index);
    if(showGroupBatchView) {
      getChosenBatch(groupBatches[index]);
    }else {
      getChosenBatch(batches[index]);
    }

  };
  const onChangeOfShedType = function (index) {
    if(index === -1) {
      setShedTypeIndex("");
      getChosenShedType("");
    } else {
      setShedTypeIndex(index);
      getChosenShedType(shedType[index]);
    }
    
  };
  const handleIncludeInActiveBatch = function (event) {
    console.debug("event ", event.target.checked, originalBatches)
    setIncludeOnlyInActiveBatch(event.target.checked);
    if (event.target.checked) {
      let tempInactiveBatches = []
      originalBatches.forEach(element => {
        console.debug(element)
        if (!element.isActive) {
          console.debug("isInactve")
          tempInactiveBatches = ([
            ...tempInactiveBatches,
            {
              ...element
            }
          ]);
        }
      });
      setBatches(tempInactiveBatches)
      //setBatches(originalBatches)
      //setBatches(originalBatches)
    } else {
      
     // setBatches(tempBatches)
      setBatches(activeBatches)
    }
  };

  return (
    // One compact row: Batch, Filter By and the inactive switch (wraps on small screens)
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 12 }}>
        <FormControl variant="outlined" size="small" className={classes.formControl} style={{ flex: isDesktop ? '0 0 220px' : '1 1 160px' }}>
          <InputLabel id="batchName-select-label">Batch</InputLabel>
          <Select
            id="batchName-select"
            labelId="batchName-select-label"
            label="Batch"
            value={batchIndex !== undefined ? batchIndex : ""}
            onChange={event => onChangeOfBatches(event.target.value)}
            name="batchIndex"
          >
            {
              showGroupBatchView ? 
              groupBatches.map((batch, index) => (
                <MenuItem key={batch.id} value={index}>
                  {batch.name}
                </MenuItem>
              ))
              :
              batches.map((batch, index) => (
                <MenuItem key={batch.id} value={index}>
                 {batch.name + " (" + batch.shedName + ")"}
                </MenuItem>
              ))
            }
            
          </Select>
        </FormControl>
        <FormControl variant="outlined" size="small" className={classes.formControl} style={{ flex: isDesktop ? '0 0 180px' : '1 1 140px' }}>
          <InputLabel id="shedType-select-label">Filter By</InputLabel>
          <Select
            id="shedType-select"
            labelId="shedType-select-label"
            label="Filter By"
            value={shedTypeIndex !== undefined ? shedTypeIndex : ""}
            onChange={event => onChangeOfShedType(event.target.value)}
            name="shedTypeIndex"
          >
            {shedType.map((elem, index) => (
              <MenuItem key={elem.id} value={index}>
                {elem.label || elem.shed_type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControlLabel
          control={
            <Switch
              checked={includeOnlyInActiveBatch}
              onChange={handleIncludeInActiveBatch}
              color="primary"
              inputProps={{ 'aria-label': 'primary checkbox' }}
            />
          }
          label="Show Inactive Batches only"
        />
    </div>
  );
};

export default SingleBatchReportInput;
